import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class PriceBookEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  ref_hdr_table?: Optional<string> = Optional.empty();
  ref_hdr_guid?: Optional<string> = Optional.empty();
  ref_line_table?: Optional<string> = Optional.empty();
  ref_line_guid?: Optional<string> = Optional.empty();
  ref_ext_table?: Optional<string> = Optional.empty();
  ref_ext_guid?: Optional<string> = Optional.empty();
}

export class PriceBookEventCriteriaModelQuery {
  query = '';

  constructor(priceBookEventCriteriaModel: PriceBookEventQueryCriteriaClass) {

    if (!priceBookEventCriteriaModel) {
      return;
    }

    this.query += priceBookEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.ref_hdr_table.filter(x => x !== '').map(x => '&ref_hdr_table=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.ref_hdr_guid.filter(x => x !== '').map(x => '&ref_hdr_guid=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.ref_line_table.filter(x => x !== '').map(x => '&ref_line_table=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.ref_line_guid.filter(x => x !== '').map(x => '&ref_line_guid=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.ref_ext_table.filter(x => x !== '').map(x => '&ref_ext_table=' + x).orElse('');
    this.query += priceBookEventCriteriaModel.ref_ext_guid.filter(x => x !== '').map(x => '&ref_ext_guid=' + x).orElse('');

    this.query += '&status=' + priceBookEventCriteriaModel.status;
    this.query += '&orderBy=' + priceBookEventCriteriaModel.orderBy;
    this.query += '&order=' + priceBookEventCriteriaModel.order;
    this.query += '&offset=' + priceBookEventCriteriaModel.offset + '&limit=' + priceBookEventCriteriaModel.limit;
  }
}
